import React, { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { taraRefundAdminContext } from "../../../context/Admin/TaraRefundAdminContext/TaraRefundAdminContext";

const TaraRefundAdmin = ({ invoice }) => {
  const {
    reason,
    setReason,
    amount,
    setAmount,
    setInvoice,
    handleRefund
  } = useContext(taraRefundAdminContext);

  const isLoader = useSelector((state) => state.isLoader);

  useEffect(() => {
    if (invoice) {
      setInvoice(invoice);
      setAmount(invoice.total || 0); // Initialize amount safely here
    }
  }, [invoice, setInvoice, setAmount]);

  return (
    <div className="card shadow-sm border-danger mt-4">
      <div className="card-header bg-danger text-white">
        <h6 className="mb-0">استرداد وجه (Refund)</h6>
      </div>
      <div className="card-body">
        <form onSubmit={handleRefund}>
          <div className="row align-items-end">
            <div className="col-md-5 mb-3 mb-md-0">
              <label className="form-label text-muted small">دلیل استرداد</label>
              <input
                type="text"
                className="form-control"
                placeholder="مثال: لغو توسط مشتری"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 mb-md-0">
              <label className="form-label text-muted small">مبلغ استرداد (ریال)</label>
              <input
                type="number"
                className="form-control"
                value={amount}
                onChange={(e) => setAmount(Number(e.target.value))}
                max={invoice?.total}
              />
            </div>
            <div className="col-md-3">
              <button 
                type="submit" 
                className="btn btn-outline-danger w-100 fw-bold"
                disabled={isLoader}
              >
                {isLoader ? "در حال پردازش..." : "ثبت استرداد"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TaraRefundAdmin;